import base from '@/__vue2stone/service/wasaapi/v1/__base';
import time from '@/service/base/time';
import store from '@/store';

export default {
  async index(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentFactory.id;
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async indexAll(factoryId, params) {
    //board calendar
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      get_all: 1,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async indexAllV2(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      get_all: 1,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'task/board/index',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async show(taskId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'task',
      modelId: taskId,
      params: _params,
    });
    return res;
  },
  async update(taskId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'task',
      modelId: taskId,
      data: _data,
    });
    return res;
  },
  async createTask(factoryId, data) {
    //create task
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task',
      data: _data,
    });
    return res;
  },
  async getTaskCurrentExpiredList(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {};
    if (type === 'organization') {
      _params = {
        ...params,
        organization: currentFactory.id,
        factory: factoryId,
      };
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task/current_expired',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async checkTask(taskId, data) {
    //check task
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'task',
      parentId: taskId,
      modelName: 'check',
      data: _data,
    });
    return res;
  },
  async delete(taskId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      modelName: 'task',
      modelId: taskId,
      params: _params,
    });
    return res;
  },
  async uncheckTask(taskId, data) {
    //uncheck task
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'task',
      parentId: taskId,
      modelName: 'uncheck',
      data: _data,
    });
    return res;
  },
  async getTaskExpiredList(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params = {
        organization: currentFactory.id,
        ...params,
      };
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task/expired',
      params: _params,
      pagination: true,
    });
    return res;
  },
  getTaskExpiredRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        date: time.getTimeFormat(item.expired_at, 'YYYY-MM-DD'),
        owner: item.taker ? item.taker : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/task-content/${item.id}`,
        },
      };
    });
    return _list;
  },
  getTaskCurrentExpiredRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        date: time.getTimeFormat(item.expired_at, 'YYYY-MM-DD'),
        owner: item.taker ? item.taker : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/task-content/${item.id}`,
        },
      };
    });
    return _list;
  },
  async subTaskIndex(taskId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      order_by: 'sequence',
      order_way: 'asc',
      ...params,
    };
    const res = await base.index({
      parentName: 'task',
      parentId: taskId,
      modelName: 'sub_task',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async subTaskIndexSearch(params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      modelName: 'sub_task',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async subTaskShow(subTaskId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'sub_task',
      modelId: subTaskId,
      params: _params,
    });
    return res;
  },
  async subTaskUpdate(subTaskId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'sub_task',
      modelId: subTaskId,
      data: _data,
    });
    return res;
  },
  async subTaskResultUpdate(subTaskId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'sub_task',
      parentId: subTaskId,
      modelName: 'result_update',
      data: _data,
    });
    return res;
  },
  async subTaskDone(subTaskId, data) {
    //check task
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'sub_task',
      parentId: subTaskId,
      modelName: 'done',
      data: _data,
    });
    return res;
  },
  async subTaskUnDone(subTaskId, data) {
    //check task
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'sub_task',
      parentId: subTaskId,
      modelName: 'undo',
      data: _data,
    });
    return res;
  },
  async subTaskDelete(subtaskId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      modelName: 'sub_task',
      modelId: subtaskId,
      params: _params,
    });
    return res;
  },
  getBoardTaskParams(statusItem, sortItem) {
    const params = {};
    if (statusItem === 'processing') {
      params.done_at = 'null';
      params.checked_at = 'null';
    } else if (statusItem === 'my-pending') {
      params.done_at = 'not_null';
      params.checked_at = 'null';
    } else if (statusItem === 'complete') {
      params.done_at = 'not_null';
      params.checked_at = 'not_null';
    }
    //Fixme:完成度排行
    if (sortItem === 'near-to-far') {
      params.order_way = 'desc';
      params.order_by = 'expired_at';
    } else if (sortItem === 'completePercent') {
      params.order_way = 'asc';
      params.order_by = 'completion_degree';
    }
    return params;
  },
  async getAuthSubtasks(params) {
    //取得 taker 為自己的 sub_tasks
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      modelName: 'auth_sub_task',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getAuthTasks(factoryId, params) {
    //取得 taker 為自己的 task
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'auth_task',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getAuthSubtaskByTask(params) {
    //取得有subtask 的taker 為自己的 task
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactory.id,
      modelName: 'auth_task_by_subtask',
      params: _params,
      pagination: true,
    });
    return res;
  },
  getAuthSubtaskParams(toDoItemSort, type = null, list = null) {
    //看板 - 我的待辦 params
    const params = {};
    if (toDoItemSort === 'hide-complete') {
      params.done_at = 'null';
    }
    if (type === 'expired') {
      params.status = 'expired';
    } else if (type === 'upcoming') {
      params.status = 'upcoming';
    }
    if (list) {
      this.pageAdd(list);
      params.page = list.page;
    }
    return params;
  },
  getByTaskParams(toDoItemSort, list = null) {
    //看板  - 我的待辦 - 依任務排序 params
    const params = {};
    if (toDoItemSort.selectedMenuItem === 'hide-complete') {
      params.sub_task_done_at = 'null';
    }
    if (list) {
      this.pageAdd(list);
      params.page = list.page;
    }
    return params;
  },
  getPageData(data, res) {
    data.lastPage = res.meta.last_page;
    data.total = res.meta.total;
    data.list = [...data.list, ...res.data];
  },
  pageAdd(list) {
    if (list.page < list.lastPage) {
      list.page++;
    }
  },
  async getSubtaskCount() {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
    };
    const res = await base.index({
      url: 'calc/auth/task',
      params: _params,
    });
    return res;
  },
  async tabIndex(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params
    };
    const res = await base.index({
      parentName: 'v1/factory',
      parentId: currentFactoryId,
      modelName: 'task/tab_index',
      params: _params,
    });
    return res;
  },
  async authIndexDraft(params) {
    const factoryId = store.state.app.factory.id;
    const _params = {
      factory: factoryId,
      ...params
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task/index/draft',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async saveDraft(data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'task/store/draft',
      data: _data,
    });
    return res;
  },
  async updateDraft(taskId, data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await base.put({
      parentName: 'factory',
      parentId: factoryId,
      modelName: `task/${taskId}/update/draft`,
      data: _data,
    });
    return res;
  },
  async subTaskIndexAll(taskId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      order_by: 'sequence',
      order_way: 'asc',
      ...params,
    };
    const res = await base.index({
      parentName: 'task',
      parentId: taskId,
      modelName: 'sub_task/index/all',
      params: _params,
      pagination: true,
    });
    return res;
  },
};
